import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { socials } from '../data/mock';
import { ArrowDown, Sparkles, ShieldCheck } from 'lucide-react';

const Hero = () => {
  const { t, lang } = useLang();
  const { content } = useContent();

  const settings = content?.settings || {};
  const heroKey = lang === 'fr' ? 'heroFr' : 'heroEn';
  const h = settings[heroKey] || {};

  const eyebrow = h.eyebrow || t.hero.eyebrow;
  const subtitle = h.subtitle || t.hero.subtitle;
  const desc = h.desc || t.hero.desc;

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const openBooking = () => window.open(socials.instagram, '_blank', 'noopener,noreferrer');

  return (
    <section id="home" className="relative min-h-screen marble-bg overflow-hidden flex items-center pt-24">
      <div className="container-tight grid lg:grid-cols-12 gap-12 items-center w-full relative z-10">
        <div className="lg:col-span-7">
          <span className="eyebrow left">{eyebrow}</span>
          <h1 className="h-display mt-8" style={{ fontSize: 'clamp(56px, 9vw, 132px)' }}>
            Devil<br />
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', fontWeight: 400, color: '#957340' }}>Tattooz</span>
          </h1>
          <div className="mt-8 max-w-xl">
            <p className="serif text-[24px] leading-[1.35] text-[#1A1A1A]" style={{ fontWeight: 400 }}>
              {subtitle}
            </p>
            <p className="mt-5 text-[15px] text-[#3A3A3A] leading-relaxed max-w-lg">
              {desc}
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-5">
            <button onClick={() => scrollTo('piercing')} className="btn-primary">
              {t.hero.cta1}
            </button>
            <button onClick={openBooking} className="btn-ghost">
              {t.hero.cta2}
            </button>
          </div>

          <div className="mt-14 flex flex-wrap items-center gap-x-10 gap-y-4 text-[11px] tracking-[0.22em] uppercase text-[#3A3A3A]">
            <span className="flex items-center gap-2"><ShieldCheck size={14} className="text-[#957340]" /> {t.hero.sterile}</span>
            <span className="flex items-center gap-2"><Sparkles size={14} className="text-[#957340]" /> {t.hero.walkin}</span>
            <span className="text-[#8A8275]">{t.hero.since}</span>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[3/4] image-hover">
            <img
              src="https://images.unsplash.com/photo-1560577938-a5ed9b19fe12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwaWVyY2luZ3xlbnwwfHx8fDE3ODIyMzY5MjZ8MA&ixlib=rb-4.1.0&q=85"
              alt="Luxury piercing"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-[#B8945B]/30 pointer-events-none" />
          </div>

          <div className="absolute -bottom-12 -left-12 hidden md:block w-[180px] aspect-[3/4] image-hover border-8 border-[#FAF8F4] shadow-2xl">
            <img
              src="https://images.pexels.com/photos/30875755/pexels-photo-30875755.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Helix"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="absolute top-6 right-6 bg-white border border-[#E8E2D5] px-5 py-4 hidden md:flex items-center gap-3 shadow-md">
            <div>
              <div className="display text-[32px] leading-[1.1] text-[#957340]">4.2</div>
              <div className="text-[9px] tracking-[0.3em] uppercase text-[#8A8275] mt-1 whitespace-nowrap">Google · 201 avis</div>
            </div>
          </div>
        </div>
      </div>

      <button onClick={() => scrollTo('about')} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 group z-10">
        <span className="text-[9px] tracking-[0.4em] uppercase text-[#8A8275] group-hover:text-[#957340] transition-colors">Scroll</span>
        <ArrowDown size={16} className="text-[#957340] animate-bounce" />
      </button>
    </section>
  );
};

export default Hero;
